// Port web de src/shared/constants/env.ts.
//
// Sur natif, la config venait de app.json → expo.extra, lu via expo-constants.
// Sur web, elle vient des variables Vite (`VITE_*`), inlinées au build.
//
// ⚠️ Tout ce qui est ici finit en clair dans le bundle. C'était déjà vrai côté
// natif (app.json est embarqué dans l'IPA/APK) : ces valeurs sont des URLs
// publiques et un client_id OIDC public, pas des secrets. Aucun secret ne doit
// être ajouté à ce fichier — un client PKCE n'a pas de client_secret.
//
// Comme sur natif, la config Keycloak réelle est récupérée au boot via
// GET /auth/keycloak/config ; les valeurs ci-dessous ne sont qu'un fallback si
// le Gateway est injoignable.

function required(value: string | undefined, name: string): string {
  if (!value) {
    throw new Error(
      `[env] Variable "${name}" manquante — la définir dans web/.env (cf. .env.example)`,
    );
  }
  return value;
}

export const env = {
  // API Gateway — toutes les requêtes REST passent par ici
  gatewayUrl: required(import.meta.env.VITE_GATEWAY_URL, "VITE_GATEWAY_URL"),

  // Realtime Gateway — Socket.IO direct (hors Gateway REST)
  realtimeUrl: required(import.meta.env.VITE_REALTIME_URL, "VITE_REALTIME_URL"),

  // Keycloak (fallback ; les vraies valeurs viennent de /auth/keycloak/config)
  keycloakUrl: required(import.meta.env.VITE_KEYCLOAK_URL, "VITE_KEYCLOAK_URL"),
  keycloakRealm: required(import.meta.env.VITE_KEYCLOAK_REALM, "VITE_KEYCLOAK_REALM"),
  keycloakClientId: required(
    import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    "VITE_KEYCLOAK_CLIENT_ID",
  ),

  // Google Maps / Routes API — remplace EXPO_PUBLIC_GOOGLE_MAPS_API_KEY.
  // Non `required()` : l'app fonctionne sans, le tracé d'itinéraire dégrade en
  // ligne droite (cf. shared/geo/routing.ts). À restreindre par referrer HTTP
  // dans la console Google Cloud.
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "",

  // Remplace le `__DEV__` de React Native.
  isDev: import.meta.env.DEV,

  exposeDevTools: import.meta.env.VITE_EXPOSE_DEV_TOOLS === "true",

  // Identifiants PUBLICS du widget tawk.to. La clé Secure Mode reste
  // exclusivement côté serveur et ne doit jamais être ajoutée ici.
  tawkPropertyId: import.meta.env.VITE_TAWK_PROPERTY_ID?.trim() ?? "",
  tawkWidgetId: import.meta.env.VITE_TAWK_WIDGET_ID?.trim() ?? "",
} as const;
